import { RouteOptions } from "../types";

const AppDashboard = () => import("@/app/dashboard/dashboard.vue");

const dashboardRoutes: RouteOptions[] = [
  {
    name: "Dashboard",
    path: "/dashboard",
    component: AppDashboard,
  },
];

export default dashboardRoutes;
